const sizes = {
  navbar: '64px',
  footer: '501px', // 528px when width < 768px
  main: 'calc(100vh - 501px)',
  mainMobile: 'calc(100vh - 528px)',
};

export default sizes;
